export enum UserStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const UserStatusOptions = [
  {
    label: "Active",
    value: UserStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: UserStatus.INACTIVE,
  },
];
